import { connect } from 'react-redux'

import CommentItem from '../../components/comments/comment-item'

function mapStateToProps (state, ownProps) {
  const comment = state.comments[ownProps.commentId]
  const user = state.users[comment.user]

  return {
    comment,
    user,
    unpinnable: ownProps.unpinnable || true
  }
}

export default connect(mapStateToProps)(CommentItem)



// WEBPACK FOOTER //
// ./src/containers/comments/comment-item-container.js